export const TAX_NUMBER_REGEX = /^[0-9]{9}$/;